<template>
  <FadeIn>
    <figure :class="'blog-img--'+ratio">
      <ImageResponsive
      v-if="content?.image"
      :data="content?.image"
      :xs="12"
      :sm="12"
      :md="10"
      :lg="12"
      :xl="12"
      classes="rounded"
      />
      <figcaption v-if="content.caption" class="mt-4 text-xs text-gray-500" v-interpolation v-html="content.caption">
      </figcaption>
    </figure>
  </FadeIn>
</template>

<script setup>
const ratio = ref('landscape')
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})

if (props.content?.image.width === props.content?.image.height) {
  ratio.value = 'square'
} else if (props.content?.image.width < props.content?.image.height) {
  ratio.value = 'portrait'
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
.blog-img {
  &--square {
    @media (min-width: $breakpoint-sm) {
      width: 50%;
    }
  }
  &--portrait {
    width: 40%;
  }
}
</style>